import { twMerge } from 'tailwind-merge';
import { useScanService } from '@witmetrics/data-store';
import { useAppState } from '@/providers/AppStateProvider';
import Card from '@/components/Card';
import ServiceTypeIcon from '@/components/ServiceTypeIcon';
import ScanServiceStatusChip from '@/components/ScanServiceStatusChip';
import { CloseIcon } from '@/icons';
import IconButton from '@/components/IconButton';
import { GRADIENTS } from './constants';
import { classes } from './utils';

export default function ServiceHeader() {
  const { activeServiceId, onClearActiveService } = useAppState();
  const scanService = useScanService(activeServiceId);

  if (!scanService) return null;

  return (
    <Card
      className={twMerge(
        classes.card,
        GRADIENTS[scanService.type] || GRADIENTS.DEFAULT
      )}>
      <div className={classes.infoWrapper}>
        <ServiceTypeIcon
          className={classes.serviceType}
          iconClassName={classes.serviceTypeIcon}
          serviceType={scanService.type}
        />
        <div>
          <div className={classes.nameWrapper}>
            <h1 className={classes.name}>{scanService.name}</h1>
            <ScanServiceStatusChip
              className={classes.status}
              status={scanService.status}
            />
          </div>
          <div className={classes.details}>
            {/*{project.unisonProjectTypeId && (*/}
            {/*  <ProjectTypeChip projectTypeId={project.unisonProjectTypeId} />*/}
            {/*)}*/}
            {/*{user && (*/}
            {/*  <button className={classes.leadButton} onClick={handleOpenLead}>*/}
            {/*    <UserChip user={user} />*/}
            {/*  </button>*/}
            {/*)}*/}
          </div>
          {/*{!isEmpty(project.description) && (*/}
          {/*  <Note className={classes.description} value={project.description} />*/}
          {/*)}*/}
        </div>
      </div>
      <div className={classes.controls}>
        <IconButton aria-label="close" onClick={onClearActiveService}>
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
      </div>
    </Card>
  );
}
